import { render, staticRenderFns } from "./onSelectionChange-editor.vue?vue&type=template&id=1513523a&scoped=true&"
import script from "./onSelectionChange-editor.vue?vue&type=script&lang=js&"
export * from "./onSelectionChange-editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1513523a",
  null
  
)

export default component.exports